/**
 * User roles.
 *
 * Kept in its own dependency-free module rather than in `User.ts` on purpose. `User.ts` imports
 * `ClientRepository`, which sits in a large import cycle, so anything reaching `Role` through
 * `User.ts` can observe it as `undefined` while that cycle is still evaluating. That is what made
 * `RoleSettingsModule`'s state initializer throw `Cannot read properties of undefined (reading
 * 'ADMIN')` when the module graph happened to be entered from `RouteGuards`.
 *
 * Keep this module a leaf: **no imports**. `User.ts` re-exports `Role`, so existing importers are
 * unaffected.
 */
export enum Role {
  ADMIN = "ADMIN",
  OFFICE = "OFFICE",
  PROJECT_MANAGER = "PROJECT_MANAGER",
  TECHNICIAN_AND_LEAK_DETECTION = "TECHNICIAN_AND_LEAK_DETECTION",
  LEAK_DETECTION = "LEAK_DETECTION",
  TECHNICIAN_1 = "TECHNICIAN_1",
  TECHNICIAN_2 = "TECHNICIAN_2",

  CUSTOM_ROLE_1 = "CUSTOM_ROLE_1",
  CUSTOM_ROLE_2 = "CUSTOM_ROLE_2",
  CUSTOM_ROLE_3 = "CUSTOM_ROLE_3",
  CUSTOM_ROLE_4 = "CUSTOM_ROLE_4",
  CUSTOM_ROLE_5 = "CUSTOM_ROLE_5",
}
